import React from 'react'
import { NavLink } from 'react-router-dom';
import { Trans } from 'react-i18next'
import { i18n } from 'shared/i18n'
import cx from 'classnames'
import './SideNavigation.css'

const MenuIcon = ({ name }) => <svg className="administration-menu-icon" width="20" height="20" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d={{
        settings: 'M4 7h7m4 0h5M4 17h3m4 0h9M11 4v6m-4 4v6M15 4v6m-4 4v6',
        facilities: 'M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6M9 9h.01M15 9h.01',
        coach: 'M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM4 21v-2a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v2M9 17l3 2 3-2',
        users: 'M14 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM2 21v-2a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v2M18 3a4 4 0 0 1 0 8m2 3a5 5 0 0 1 2 4v3',
        calendar: 'M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2ZM16 3v4M8 3v4M3 11h18m-14 5h2m4 0h2',
    }[name] || 'M4 5h16M4 12h16M4 19h16'} />
</svg>

// Entries carry their path, title, icon and optional group. Pass only entries
// available to this user; desktop and mobile render the same menu.
export const SideNavigation = ({ options, onNavigate }) => {
    const groups = [...new Set(options.map(option => option.group))]

    return <nav className="administration-navigation" aria-label={i18n().t('Administration')}>
        <h2 className="administration-menu-title"><Trans>Administration</Trans></h2>
        {groups.map(group => <div className="administration-menu-group" key={group || 'ungrouped'}>
            {group && <h3><Trans>{group}</Trans></h3>}
            <ul>
                {options.filter(option => option.group === group).map(({ path, title, icon }) => <li key={path}>
                    <NavLink to={path} onClick={onNavigate}>
                        <MenuIcon name={icon} /><span><Trans>{title}</Trans></span>
                    </NavLink>
                </li>)}
            </ul>
        </div>)}
    </nav>
}

export const ContainerWithSideNav = ({ options, wide, children }) => {
    return <div className="side-nav-container">
        <aside className="side-panel"><SideNavigation options={options} /></aside>
        <div className={cx({
            "main-panel": true,
            "capped": !wide,
        })}>
            {wide
                ? children
                : <div className="main-panel-inner">{children}</div>
            }
        </div>
    </div>
}
